import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=32f3b97e&"
import script from "./mail.vue?vue&type=script&lang=js&"
export * from "./mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports